import H6 from "@/components/ui/headings/H6";
import Paragraph from "@/components/ui/paragraph";
import { useTranslations } from "@/lib/static-intl";
import { useCallback } from "react";
import DropzoneVidUploader from "./dropzone-vid-uploader";
import { checkVideoFile } from "@/utils/helpers";

const MAX_VIDEO_UPLOAD_SIZE_BYTES = 200 * 1024 * 1024;

const VidUploader = ({ setNoteDetails }) => {
  const t = useTranslations("creator_service.create_note_media_upload");
  const handleDrop = useCallback((acceptedFiles) => {
    const newFiles = acceptedFiles.slice(0, 1).map((file) => {
      if (checkVideoFile(file)) {
        return Object.assign(file, {
          preview: URL.createObjectURL(file),
        });
      }
    });
    console.log("newFiles-->", newFiles);
    setNoteDetails((prev) => ({
      ...prev,
      media: [...(prev?.media || []), ...newFiles],
    }));
  }, []);

  const operation = [
    {
      title: "Video size",
      description: "short_video_size_desc",
    },
    {
      title: "Video Format",
      description:
        "Support common video formats, It is recommended to use mp4, mov",
    },
    {
      title: "Video resolution",
      description: "video_resolution_desc",
    },
  ];
  return (
    <div className="w-full md:h-full flex flex-col md:flex-row gap-2 md:gap-8 items-center justify-center dark:bg-brown rounded-lg bg-white px-5 md:px-8">
      <DropzoneVidUploader
        className="min-h-72 md:min-h-[60vh]"
        thumbnail
        name="file"
        maxSize={MAX_VIDEO_UPLOAD_SIZE_BYTES}
        onDrop={handleDrop}
        files={[]}
        multiple
      />
      <div className="min-h-72 md:min-h-[65vh] flex flex-col gap-5 md:gap-8 justify-evenly pb-16 md:pb-0">
        {operation?.map((item, ind) => (
          <div
            className="w-full flex justify-center items-center flex-col border dark:border-brown border-gray-200 py-8 px-12 rounded md:rounded-lg"
            key={ind}
          >
            <H6 className="text-center !font-semibold">{t(item?.title)}</H6>
            <Paragraph className="text-center !text-xs">
              {t(item?.description)}
            </Paragraph>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VidUploader;
